import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import {
  WorkflowPipelineActionRequest,
  WorkflowPipelineActionResponse,
  WorkflowPipelinePreviewRequest,
  WorkflowPipelinePreviewResponse
} from '../models/workflow-pipeline-action.model';

@Injectable({ providedIn: 'root' })
export class WorkflowPipelineActionApiService {
  private readonly apiUrl = `${environment.apiUrl}api/workflow-actions`;

  constructor(private http: HttpClient) {}

  test(request: WorkflowPipelineActionRequest): Observable<WorkflowPipelineActionResponse> {
    return this.http.post<WorkflowPipelineActionResponse>(
      `${this.apiUrl}/pipeline/test`,
      request
    );
  }

  preview(request: WorkflowPipelinePreviewRequest): Observable<WorkflowPipelinePreviewResponse> {
    return this.http.post<WorkflowPipelinePreviewResponse>(
      `${this.apiUrl}/pipeline/preview`,
      request
    );
  }
}
